/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-argument */
// @ts-nocheck — Relay-generated types from duet-network-theverge; CSK compile succeeds without building that app first.
import { LIVE_RESOURCE_METADATA_CONCRETE_REQUEST } from "@src/utils/csk-query-concrete-requests";
import {
  createContext,
  FunctionComponent,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { fetchQuery, useRelayEnvironment } from "react-relay";

import type { cskQueryLiveResourceMetadataQuery } from "@src/__generated__/relay/cskQueryLiveResourceMetadataQuery.graphql";

interface CskLiveResourceMetadataContextValue {
  /** Whether a client-side metadata refresh is active for this page. */
  enabled: boolean;
  /** True once the refresh fetch has settled (success or failure). */
  isReady: boolean;
}

const defaultContextValue: CskLiveResourceMetadataContextValue = {
  enabled: false,
  isReady: true,
};

const CskLiveResourceMetadataContext =
  createContext<CskLiveResourceMetadataContextValue>(defaultContextValue);

export function useCskLiveResourceMetadata(): CskLiveResourceMetadataContextValue {
  return useContext(CskLiveResourceMetadataContext);
}

/** Fetches publish-time fields into the Relay store; returns readiness for gating. */
export function useCskLiveResourceMetadataRefresh(
  nodeId: string,
  enabled: boolean,
): boolean {
  const environment = useRelayEnvironment();
  const [isReady, setIsReady] = useState(!enabled);

  useEffect(() => {
    if (!enabled) {
      setIsReady(true);
      return;
    }

    setIsReady(false);
    let cancelled = false;

    fetchQuery<cskQueryLiveResourceMetadataQuery>(
      environment,
      LIVE_RESOURCE_METADATA_CONCRETE_REQUEST,
      { nodeId },
    )
      .toPromise()
      .then(() => {
        if (!cancelled) {
          setIsReady(true);
        }
      })
      .catch(() => {
        console.error("Could not refresh live resource metadata for CSK page");
        if (!cancelled) {
          setIsReady(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, environment, nodeId]);

  return isReady;
}

interface ProviderProps {
  nodeId: string;
  enabled?: boolean;
  children: ReactNode;
}

/**
 * Fetches publish-time CMS fields after hydration and merges them into the Relay
 * store so fragments (lede, SEO, analytics, Zephr) re-render with live data.
 */
export const CskLiveResourceMetadataProvider: FunctionComponent<
  ProviderProps
> = ({ nodeId, enabled = false, children }) => {
  const isReady = useCskLiveResourceMetadataRefresh(nodeId, enabled);

  const value = useMemo(
    () => ({
      enabled,
      isReady,
    }),
    [enabled, isReady],
  );

  return (
    <CskLiveResourceMetadataContext.Provider value={value}>
      {children}
    </CskLiveResourceMetadataContext.Provider>
  );
};
